const SHORTCUTS = [
  {
    group: 'Навигация',
    items: [
      { keys: ['Ctrl', 'K'], desc: 'Быстрый переключатель чатов' },
      { keys: ['Ctrl', 'Shift', 'F'], desc: 'Глобальный поиск' },
      { keys: ['Ctrl', 'F'], desc: 'Поиск в чате' },
      { keys: ['Alt', '←'], desc: 'Предыдущий чат' },
      { keys: ['Alt', '→'], desc: 'Следующий чат' },
      { keys: ['Esc'], desc: 'Закрыть / назад' },
    ],
  },
  {
    group: 'Сообщения',
    items: [
      { keys: ['Enter'], desc: 'Отправить сообщение' },
      { keys: ['Shift', 'Enter'], desc: 'Отправить без звука' },
      { keys: ['↑'], desc: 'Изменить последнее сообщение' },
    ],
  },
  {
    group: 'Форматирование',
    items: [
      { keys: ['Ctrl', 'B'], desc: 'Жирный' },
      { keys: ['Ctrl', 'I'], desc: 'Курсив' },
      { keys: ['Ctrl', 'U'], desc: 'Подчёркнутый' },
      { keys: ['Ctrl', 'E'], desc: 'Моноширинный' },
      { keys: ['Ctrl', 'Shift', 'X'], desc: 'Зачёркнутый' },
      { keys: ['Ctrl', 'Shift', 'P'], desc: 'Спойлер' },
    ],
  },
  {
    group: 'Другое',
    items: [
      { keys: ['Ctrl', '/'], desc: 'Показать горячие клавиши' },
    ],
  },
]

export function ShortcutsModal({ onClose }: { onClose: () => void }) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 animate-fade-in"
      onClick={onClose}
    >
      <div
        className="bg-bg-primary rounded-2xl w-full max-w-md mx-4 overflow-hidden shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-divider">
          <h2 className="text-txt-primary font-semibold text-base">Горячие клавиши</h2>
          <button
            onClick={onClose}
            className="text-txt-secondary hover:text-txt-primary transition-colors"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-4 space-y-5 max-h-[70vh] overflow-y-auto">
          {SHORTCUTS.map((group) => (
            <div key={group.group}>
              <p className="text-txt-secondary text-xs uppercase tracking-wider font-medium mb-2">
                {group.group}
              </p>
              <div className="space-y-1.5">
                {group.items.map((item) => (
                  <div key={item.desc} className="flex items-center justify-between">
                    <span className="text-txt-primary text-sm">{item.desc}</span>
                    <div className="flex items-center gap-1">
                      {item.keys.map((k) => (
                        <kbd
                          key={k}
                          className="bg-bg-input text-txt-secondary text-xs px-2 py-0.5 rounded-lg font-mono border border-divider"
                        >
                          {k}
                        </kbd>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
